const host = window.location.host;
let imgPath = 'https://coc.sqifu.com/image/';
let apiPath = 'https://ctapi.sqifu.com/image/';
let api = "https://ctapi.sqifu.com/api/v1";
let baseUrl = "https://coc.sqifu.com";
if (/ct.newcoc.cn/g.test(host)) {
    imgPath = "https://ctapi.sqifu.com/image/";
    apiPath = "https://ctapi.sqifu.com/api/";
    api = "https://ctapi.sqifu.com/api/v1";
    baseUrl = "https://ctapi.sqifu.com";
}

export default {
    imgPath,
    apiPath,
    api,
    baseUrl,
    cookieExpires: 7,
    menu: [],
    cityId: 2
}


// WEBPACK FOOTER //
// ./src/config/index.js